import React from 'react';
import fscreen from 'fscreen';
import { ReactComponent as FullscreenIcon } from '../icons/fullscreen.svg';

class FullscreenSwitch extends React.Component {

    //this fork has been quickly revamped to fit all UI onto images 
    // → App must NOT be set fullscreen so we blindly use .parentNode to get #root
    // do not reuse this component as is

    constructor(props) {
        super(props);
        this.state = {
            fullscreenEnabled: false
        }
    }

    componentDidMount = () => {
        fscreen.addEventListener('fullscreenchange', this.handleFullScreenChange);

    }

    componentWillUnmount = () => {
        fscreen.removeEventListener('fullscreenchange', this.handleFullScreenChange);
    }

    handleFullScreenChange = () => {
        this.setState({ fullscreenEnabled: fscreen.fullscreenElement === this.props.targetRef.current.parentNode });
    }

    toggleFullscreen = () => {
        if (this.state.fullscreenEnabled)
            fscreen.exitFullscreen();
        else
            fscreen.requestFullscreen(this.props.targetRef.current.parentNode);
    }

    render() {
        return <FullscreenIcon id="FullscreenSwitch" onClick={this.toggleFullscreen} />;
    }
}

export default FullscreenSwitch;